import type { SVGProps } from 'react'
const LineMaximizeAlt03 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M14 3h5.75c.69 0 1.25.56 1.25 1.25V10h-1.5V5.56l-3.72 3.72-1.06-1.06 3.72-3.72H14zM8.22 14.72l1.06 1.06-3.72 3.72H10V21H4.25C3.56 21 3 20.44 3 19.75V14h1.5v4.44zM3 4.25V10h1.5V5.56l3.72 3.72 1.06-1.06L5.56 4.5h4.94V3H4.25C3.56 3 3 3.56 3 4.25m12.78 10.47 3.72 3.72V14H21v5.75c0 .69-.56 1.25-1.25 1.25H14v-1.5h4.44l-3.72-3.72z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineMaximizeAlt03 }
